/* HARD ON 3D — homepage section behaviour. Loaded as a module; safe to include from multiple sections. */
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
document.documentElement.classList.add('h3d-js');

let CartLinesUpdateEvent = null;
import('@shopify/events')
  .then((m) => { CartLinesUpdateEvent = m.CartLinesUpdateEvent; })
  .catch(() => {});

const io = new IntersectionObserver((entries) => {
  entries.forEach((e) => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  });
}, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

function toast(msg) {
  let el = document.querySelector('[data-h3d-toast]');
  if (!el) {
    el = document.createElement('div');
    el.className = 'h3d-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.dataset.h3dToast = '';
    document.body.appendChild(el);
  }
  el.textContent = msg;
  el.classList.add('is-on');
  clearTimeout(el._t);
  el._t = setTimeout(() => el.classList.remove('is-on'), 2600);
}

async function addToCart(form, btn) {
  const id = form.querySelector('[name="id"]').value;
  const title = btn.dataset.title || 'Item';
  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = '…';
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId).filter(Boolean);
  const deferred = CartLinesUpdateEvent ? CartLinesUpdateEvent.createPromise() : null;
  if (deferred) {
    btn.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product',
      lines: [{ merchandiseId: String(id), quantity: 1 }],
      promise: deferred.promise,
    }));
  }
  const routes = (window.Theme && window.Theme.routes) || {};
  const addUrl = routes.cart_add_url || '/cart/add';
  const cartUrl = (routes.cart_url || '/cart') + '.js';
  try {
    const res = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sectionIds.join(',') }),
    }).then((r) => r.json());
    const cart = await fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const failed = Boolean(res && res.status);
    if (deferred) {
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'h3d-card', sourceId: 'h3d', itemCount: 1, sections: res.sections, didError: failed },
      });
    }
    if (failed) {
      btn.textContent = 'Sold out';
      toast(res.description || res.message || 'Could not add to cart');
    } else {
      btn.classList.add('is-added');
      btn.textContent = 'Added';
      toast(`${title} added to cart`);
      if (!deferred) window.location.href = routes.cart_url || '/cart';
    }
  } catch (err) {
    if (deferred) deferred.reject(err);
    form.submit(); // no-JS style fallback
    return;
  }
  setTimeout(() => { btn.classList.remove('is-added'); btn.textContent = original; btn.disabled = false; }, 1800);
}

function init(root) {
  root.querySelectorAll('.h3d-reveal, .h3d-step').forEach((el) => io.observe(el));

  root.querySelectorAll('.h3d-card').forEach((card) => {
    card.addEventListener('pointermove', (ev) => {
      const r = card.getBoundingClientRect();
      card.style.setProperty('--mx', `${ev.clientX - r.left}px`);
      card.style.setProperty('--my', `${ev.clientY - r.top}px`);
    });
  });

  root.querySelectorAll('form[data-h3d-add]').forEach((form) => {
    form.addEventListener('submit', (ev) => {
      ev.preventDefault();
      addToCart(form, form.querySelector('button'));
    });
  });

  const tilt = root.querySelector('[data-tilt]');
  if (tilt && !reduce && matchMedia('(min-width: 901px)').matches) {
    const hero = tilt.closest('section');
    hero.addEventListener('pointermove', (ev) => {
      const r = hero.getBoundingClientRect();
      const x = (ev.clientX - r.left) / r.width - 0.5;
      const y = (ev.clientY - r.top) / r.height - 0.5;
      tilt.style.transform = `perspective(1400px) rotateY(${-6 + x * 8}deg) rotateX(${2 - y * 6}deg)`;
    });
    hero.addEventListener('pointerleave', () => { tilt.style.transform = ''; });
  }

  const track = root.querySelector('[data-rail-track]');
  root.querySelectorAll('[data-rail]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const card = track && track.querySelector('.h3d-card');
      const step = card ? card.getBoundingClientRect().width + 16 : 260;
      track.scrollBy({ left: step * Number(btn.dataset.rail), behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  const builder = root.querySelector('[data-h3d-builder]');
  if (builder) {
    const input = builder.querySelector('input');
    const nameEl = builder.querySelector('[data-tag-name]');
    const tag = builder.querySelector('[data-tag]');
    const sws = [...builder.querySelectorAll('.h3d-sw')];
    let touched = false;
    const setColor = (sw) => {
      if (!sw) return;
      sws.forEach((s) => s.setAttribute('aria-pressed', String(s === sw)));
      const c = sw.dataset.c;
      const glow = sw.dataset.glow || `${c}99`;
      nameEl.style.setProperty('--tag-color', c);
      nameEl.style.setProperty('--tag-glow', glow);
      tag.style.setProperty('--tag-glow', glow);
    };
    sws.forEach((sw) => sw.addEventListener('click', () => { touched = true; setColor(sw); }));
    setColor(builder.querySelector('.h3d-sw[aria-pressed="true"]') || sws[sws.length - 1]);
    ['focus', 'input', 'pointerdown'].forEach((e) => input.addEventListener(e, () => { touched = true; }));
    input.addEventListener('input', () => { nameEl.textContent = input.value.trim() || input.placeholder || 'Your name'; });
    const names = (builder.dataset.names || '').split(',').map((s) => s.trim()).filter(Boolean);
    if (names.length > 1 && !reduce) {
      let i = 0;
      const t = setInterval(() => {
        if (touched || !document.body.contains(builder)) return clearInterval(t);
        i = (i + 1) % names.length;
        input.value = names[i];
        nameEl.textContent = names[i];
        setColor(sws[(i + 3) % sws.length]);
      }, 2200);
    }
  }

  const adult = root.querySelector('[data-reveal-adult]');
  if (adult) {
    const b = adult.querySelector('button');
    if (b) b.addEventListener('click', () => adult.classList.add('is-revealed'));
  }

  root.querySelectorAll('video[autoplay]').forEach((v) => {
    v.muted = true;
    v.setAttribute('playsinline', '');
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  });
}

document.querySelectorAll('[data-h3d-section]').forEach((s) => {
  if (s.dataset.h3dReady) return;
  s.dataset.h3dReady = '1';
  init(s);
});

document.addEventListener('shopify:section:load', (e) => {
  e.target.querySelectorAll('[data-h3d-section]').forEach((s) => { s.dataset.h3dReady = '1'; init(s); });
});
